import $ from 'jquery';
import 'jqtree';
import 'jqtree/jqtree.css';

export default class CustomerSegment {
  static searchSegmentsInit() {
    const $input = $('.js__segments-autocomplete');
    if (!$input.length) {
      return;
    }

    const path = $input.data('path');
    const segments = [];
    segments.push($input.val());

    if ($input.find('.js__segments-autocomplete').val() !== '') {
      $input.find('input').not('.js__segments-autocomplete').val($input.find('.js__segments-autocomplete').val());
    }

    $input.search({
      cache: false,
      minCharacters: 3,
      type: 'standard',
      onSelect: data => {
        const selectedSegment = data.id;
        const selectedSegmentName = data.title;
        $input.find('.js__input-segment').val(selectedSegment).attr('data-name', selectedSegmentName);
      },
      apiSettings: {
        url: path,
        method: 'GET',
        data: {
          phrase: segments.join(','),
        },
        beforeSend: function (settings) {
          settings.data.phrase = $input.find('input').val();
          return settings;
        },
        onResponse: results => {
          setTimeout(() => {
            $.each(results, (index, item) => {
              const status = item.enabled ? 'enabled' : 'disabled';

              $($input.find(`.description`)[Number(index)]).addClass(`autocomplete-status ${status}`);
            });
          }, 100);

          const response = {
            results: [],
          };

          $.each(results, (index, item) => {
            response.results.push({
              id: item.id,
              title: item.title,
              description: item.enabled ? 'enabled' : 'disabled',
            });
          });
          return response;
        },
      },
    });
  }
}
